export const enum TranscodingStatus {
  InDownloadQueue = 'IN-DOWNLOAD-QUEUE',
  Uploading = 'UPLOADING',
  InStorage = 'IN-STORAGE',
  InQueue = 'IN-QUEUE',
  Pending = 'PENDING',
  InProgress = 'INPROGRESS',
  Ready = 'READY',
  Failed = 'FAILED',
  None = 'NONE',
}
